import { render, staticRenderFns } from "./systemHelp.vue?vue&type=template&id=0654fc21&scoped=true"
import script from "./systemHelp.vue?vue&type=script&lang=js"
export * from "./systemHelp.vue?vue&type=script&lang=js"
import style0 from "./systemHelp.vue?vue&type=style&index=0&id=0654fc21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654fc21",
  null
  
)

export default component.exports